'use client'
import './cleopatraContent.scss'

import React, { useEffect, useState } from 'react'

import spriteUrl from '@/src/shared/images/v4/css_sprites_compr.png'
import bgUrl from '@/src/shared/images/v4/roma-bg.jpg'

import { spriteData } from './data'

const CleopatraContent = () => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const spriteImg = new Image()

    setIsLoaded(true)

    spriteImg.src = spriteUrl.src
  }, [])

  useEffect(() => {
    if (!isLoaded) return

    const scene = document.querySelector('.sprite-scene')
    const eventType = 'scroll'
    if (!scene) return

    const layers = scene.querySelectorAll('.layer') as NodeListOf<HTMLElement>
    let ticking = false

    const handleScroll = () => {
      const sceneTop = scene.getBoundingClientRect().top + window.scrollY
      const sceneHeight = scene.clientHeight
      const scrollY = window.scrollY
      const progress = Math.min(Math.max((scrollY - sceneTop) / sceneHeight, 0), 1)

      layers.forEach((el) => {
        const speed = parseFloat(el.dataset.speed || '1')
        const effect = el.dataset.effect || 'translate'
        const dx = parseFloat(el.dataset.dx || '0')
        const dy = parseFloat(el.dataset.dy || '0')

        if (effect === 'translate') {
          const x = dx * progress * speed
          const y = dy * progress * speed
          el.style.transform = `translate(${x}px, ${y}px)`
        } else if (effect === 'scale') {
          const scale = 1 + progress * speed * 0.3
          el.style.transform = `scale(${scale})`
        } else {
          el.style.transform = ''
        }
      })

      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(handleScroll)
        ticking = true
      }
    }

    window.addEventListener(eventType, onScroll)
    handleScroll()

    return () => window.removeEventListener(eventType, onScroll)
  }, [isLoaded])

  return (
    <div className="cleopatra-wrapper">
      {isLoaded && (
        <div className="sprite-scene-wrapper">
          <div className="sprite-scene" style={{ backgroundImage: `url('${bgUrl.src}')` }}>
            {spriteData.map((sprite, i) => {
              const commonStyle: React.CSSProperties = {
                width: sprite.w,
                height: sprite.h,
                backgroundImage: `url('${spriteUrl.src}')`,
                backgroundPosition: `-${sprite.x}px -${sprite.y}px`,
                backgroundRepeat: 'no-repeat',
                willChange: 'transform',
                position: 'absolute',
                top: sprite.top ?? 0,
                left: sprite.left ?? 0,
              }

              const dataAttrs = {
                'data-speed': sprite.speed ?? 1,
                'data-effect': sprite.effect ?? 'translate',
                'data-dx': sprite.dx ?? 0,
                'data-dy': sprite.dy ?? 0,
              }

              return (
                <div
                  key={i}
                  className={`sprite ${sprite.class} layer`}
                  {...dataAttrs}
                  style={commonStyle}
                />
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default CleopatraContent
